export default {
	restoringConnection: 'Restoring connection',
	connectionPreviouslyExisted: 'This connection previously existed and will be restored',
	measuresWillBeEnabled: 'measures will be enabled',
	assetAlreadyConnected: 'This asset is already connected to this module — please select a different one.',
	assetDuplicateInModule: 'This asset is already selected for another group of the same module — please select a different one.',
	moduleWillBeActivated: 'Module will be activated',
	withChanges: 'with changes',
	noChanges: 'no changes',
	found: 'found',
	secNeedWarning: 'security need',
	importSummary: 'Import summary',
	detected: 'Detected',
	attentionRequired: 'Attention required',
	selected: 'selected',
	readyToImport: 'ready to import',
	missingRequirements: 'missing requirements',
	nameMismatchWarning: 'method descriptions differ from the current standard — the file may have been exported from a different version.',
	assetMissing: 'No asset',
	bpMissing: 'No business process',
	versionMismatch: 'Version mismatch',
	statusMismatch: 'Status mismatch',
	responsibleNotFound: 'Responsible not found',
	deselectSecurityWarnings: 'Deselect exceeding',
	deselectSecurityWarningsInfo: 'You can import data, but methods won\'t appear unless you update the organisation\'s security need.',
	approveVersionMismatch: 'Approve version mismatch',
	approveVersionMismatchWarning: 'These measures may originate from an older version of the standard. Please verify they still match the current version before applying.',
	chooseStatusReplacement: 'Replace status',
	required: 'required',
	resolveStatusMismatches: 'Replace all custom statuses to continue',
	noChangesDetected: 'No changes detected',
	dontImport: "Don't import",
	expandAll: 'Expand all',
	collapseAll: 'Collapse all',
	columnMappingRequired: 'Column headers were not recognised. Map each file column to the expected field below.',
	field: 'Field',
	columnInFile: 'Column in file',
	responsible: 'Responsible',
	methodDescription: 'Method description',
	matchedFromFile: 'Matched from file',
	matchedFromFileInfo: 'Asset and/or business process(es) were matched by name from the file and pre-selected.',
	fileAssetNotInSystem: 'In file: \'{name}\' — not in system',
	importNew: 'new',
	importNotFound: 'not found',
	importPlan: 'Import plan',
}
